import dayjs from 'dayjs';

const formatter = Intl.NumberFormat('en', { notation: 'compact' });

// converts date from YYYY-MM-DD to local format
export const prettyPrintDate: (date: string) => string = (date: string) => {
  // return new Date(date).toLocaleDateString();
  return dayjs(date).format('MM/DD');
};

export type DataValue = {
  x: string;
  y: number;
};

export const formatToCompactNumber = (total: number): string => formatter.format(total ?? 0);

export const getValue = (value: number | null | undefined): number =>
  typeof value === 'number' ? value : 0;

/**
 * Appends the market selected on the dashboard to a list-page link, so the target page opens
 * with the same market preselected. No-op when "All Markets" is selected.
 */
export const withMarket = (link: string, marketID?: string | null): string => {
  if (!marketID || marketID === 'all') return link;
  return `${link}${link.includes('?') ? '&' : '?'}marketID=${encodeURIComponent(marketID)}`;
};
